import React from "react";

import Modal from "../Modal";
import Button from "../Button";

import "./index.scss";

export default function SpecialDatesModal(props){
    return (
        <Modal
            className="specialDatesModal"
            title={props.specialDates.title}
            open={props.open}
            closeFn={() => props.closeModal()}
            footerContent={
                <React.Fragment>
                    <Button onClick={() => props.closeModal()} className="primary">Ok</Button>
                </React.Fragment>
            }
        >
            {props.specialDates.message}
        </Modal>
    )
}